<template>
  <div>
    <v-expansion-panel v-model="inPanelTraslado" expand inset>
      <v-expansion-panel-content
        :class="isSelected(item.idTarifa) ? 'traslado-selected' : ''"
        :disabled="isDisabled(item.direccion)"
        v-for="(item, i) in toArray(data.traslados)"
        :key="i"
      >
        <template v-slot:actions>
          <v-icon color="primary" class="body-1">$vuetify.icons.expand</v-icon>
        </template>
        <template v-slot:header>
          <div>
            <v-layout row wrap>
              <v-flex xs1 title="ida">
                <v-icon color="green lighten-2" small v-if="item.direccion == 'I'">
                  fas fa-arrow-right
                </v-icon>
                <v-icon color="red lighten-1" small v-else-if="item.direccion == 'O'">
                  fas fa-arrow-left
                </v-icon>
                <v-icon color="yellow darken-4" small v-else>
                  fas fa-arrows-alt-h
                </v-icon>
              </v-flex>
              <v-flex xs4>
                <p class="text-center mb-0 text-capitalize">Servicio {{ item.tipo.toLowerCase() }}</p>
              </v-flex>
              <v-flex xs4>
                <p class="text-center mb-0 text-capitalize">
                  {{ item.nombre.toLowerCase() }}
                </p>
              </v-flex>
              <v-flex xs3>
                <p class="text-center mb-0" v-if="item.tarifas.totales.venta > 0">
                  {{ item.tarifas.totales.moneda }}
                  {{ item.tarifas.totales.venta }}
                  <v-icon color="green" small v-if="isSelected(item['@attributes'].idTicket)"
                    >fas fa-check-circle</v-icon
                  >
                </p>
                <p v-else class="text-center mb-0 green--text darken-4">
                  Free
                </p>
              </v-flex>
            </v-layout>
          </div>
        </template>
        <PanelTraslado
          :item="item"
          :hotel="data.hotel"
          :unico="data.unico_hotel"
          :seleccionado="isSelected(item.idTarifa)"
        >
        </PanelTraslado>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
import PanelTraslado from "@/components/traslados/PanelTraslado.vue"
export default {
  name: "traslados",
  props: ["data", "seleccionados"],
  components: {
    PanelTraslado
  },
  mounted() {},
  beforeCreate() {},
  methods: {
    isDisabled(tipo) {
      switch (tipo) {
        case "X":
          return !(this.seleccionados.findIndex(s => s.direccion === "O" || s.direccion === "I") === -1)
        case "O":
          return !(this.seleccionados.findIndex(s => s.direccion === "X" || s.direccion === "O") === -1)
        case "I":
          return !(this.seleccionados.findIndex(s => s.direccion === "X" || s.direccion === "I") === -1)
        default:
          throw Error()
          break
      }
    },
    isSelected(traslado_id) {
      return !(this.seleccionados.findIndex(s => s.idTarifa === traslado_id) === -1)
    },
    getIconos(direccion) {
      const iconos = this.iconosDirecciones.find(iD => iD.tipo === direccion)
      return iconos.iconos
    }
  },
  data() {
    return {
      panelTraslado: [false],
      inPanelTraslado: [false],
      iconosDirecciones: [
        {
          tipo: "I",
          iconos: [
            { icon: "fas fa-plane", color: "grey darken-1" },
            { icon: "fas fa-arrow-right", color: "green lighten-2" },
            { icon: "fas fa-hotel", color: "grey darken-1" }
          ]
        },
        {
          tipo: "O",
          iconos: [
            { icon: "fas fa-plane", color: "grey darken-1" },
            { icon: "fas fa-arrow-left", color: "red lighten-1" },
            { icon: "fas fa-hotel", color: "grey darken-1" }
          ]
        },
        {
          tipo: "X",
          iconos: [
            { icon: "fas fa-plane", color: "grey darken-1" },
            { icon: "fas fa-arrows-alt-h", color: "yellow lighten-1" },
            { icon: "fas fa-hotel", color: "grey darken-1" }
          ]
        }
      ]
    }
  },
  computed: {
    cerrar() {
      return true
    }
  },
  watch: {
    seleccionados: function(newVal) {
      // watch it
      this.inPanelTraslado = []
      /* if (newVal.length === 2) {
                 this.inPanelTraslado = [];
                 }
                 if (newVal.find(n => n.direccion === 'X')) {
                 this.inPanelTraslado = [];
                 }*/
    }
  }
}
</script>
<style scoped>
.traslado-selected {
  background-color: #b2dfdb !important;
}
</style>
